var exports = {
  "og": "x112a1f60--9c1c60--seller",
  "JM": "x112a1f60--9c1c60--seller-title",
  "Mc": "x112a1f60--9c1c60--seller-logo",
  "n9": "x112a1f60--9c1c60--seller-info",
  "o4": "x112a1f60--9c1c60--seller-name",
  "NU": "x112a1f60--9c1c60--seller-label",
};

module.exports = exports;
